import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Grid,
  IconButton,
} from "@mui/material";
import { useLoaderData, useNavigate } from "react-router-dom";

import ContentPasteSearchIcon from "@mui/icons-material/ContentPasteSearch";
import SyncIcon from "@mui/icons-material/Sync";

import { useState } from "react";
import useCheckPermission from "../../../../common/hooks/useCheckPermission";
import useGetPageInfo from "../../../../common/hooks/useGetPageInfo";
import BreadcrumbsComponent from "../../../../components/shared/breadcrumbs";
import EnhancedTable from "../../../../components/shared/table";
import RequestMapDialog from "./RequestMapDialog";

const ContractorInProcessRequestPage = () => {
  const pageInfo = useGetPageInfo();
  const dataList = useLoaderData("root");
  let navigate = useNavigate();

  const [selectedRequest, setSelectedRequest] = useState({
    open: false,
    id: null,
  });
  const headCells = [
   {
      id: "updateOn",
      label: "تاریخ",
      type: "date",
    },

    {
      id: "firstName",
      label: "نام",
    },
    {
      id: "lastName",
      label: "نام خانوادگی",
    },

    {
      id: "referenceID",
      label: "شناسه درخواست",
    },
    {
      id: "powerPlantTypeTitle",
      label: "نوع نیروگاه",
    },
    {
      id: "locationUsageTypeTitle",
      label: "کاربری محل",
    },
    {
      id: "installableAreaSquareMeterDisplay",
      label: "مساحت قابل نصب",
    },
    {
      id: "expireDate",
      label: "تاریخ اعتبار",
      type: "date",
    },
    {
      id: "stepTitle",
      label: "مرحله فعلی",
    },

    {
      id: "requestConfirmTitle",
      label: "وضعیت درخواست",
    },
    {
      id: "cityName",
      label: "شهرستان",
    },
  ];

  const onEditClicked = (row) => {
    navigate(`${row.id}`);
  };

  const onFetchData = () => {
    navigate();
  };

  const onOpenRequestMap = (row) => {
    setSelectedRequest({
      open: true,
      id: row.id,
    });
  };

  const rows = (Array.isArray(dataList) ? dataList : []).map((row) => ({
    ...row,
    installableAreaSquareMeterDisplay:
      row.installableAreaSquareMeter != null
        ? row.installableAreaSquareMeter
        : "ثبت نشده",
  }));

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={12}>
        <BreadcrumbsComponent />
      </Grid>

      <RequestMapDialog
        open={selectedRequest.open}
        onClose={() => {
          setSelectedRequest({
            open: false,
            id: null,
          });
        }}
        id={selectedRequest.id}
      />

      <Grid item xs={12} md={12}>
        <Card>
          <CardHeader
            title={pageInfo.title}
            action={
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "fit-content",
                }}
              >
                <IconButton
                  variant="text"
                  color="primary"
                  onClick={onFetchData}
                >
                  <SyncIcon />
                </IconButton>
              </Box>
            }
          />

          <CardContent>
            <Grid container>
              <Grid item xs={12} md={12}>
                <EnhancedTable
                  rowKey={"id"}
                  rows={rows}
                  headCells={headCells}
                  defaultSort={{ orderBy: "updateOn", order: "desc" }}
                  pageSize={100}
                  actions={[
                     
                    {
                      icon: useCheckPermission("edit") ? (
                        <ContentPasteSearchIcon />
                      ) : null,
                      onClick: onEditClicked,
                      color: "primary",
                      tooltip: "بررسی",
                    },
                  ]}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default ContractorInProcessRequestPage;
